import React from 'react';

const GretaLogo: React.FC<{ className?: string }> = ({ className }) => {
    return (
        <svg
            className={className}
            width="96"
            height="91"
            viewBox="0 0 96 91"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M50.0879 0C75.4443 0 96 20.371 96 45.5C96 70.629 75.4443 91 50.0879 91C39.2274 90.9999 29.2497 87.2602 21.3887 81.0127L0.419922 83.7617L10.4141 68.4072C6.45015 61.6791 4.17676 53.8531 4.17676 45.5C4.17676 20.3712 24.7317 0.000212257 50.0879 0ZM36.7324 67.4229C35.0036 67.4229 33.6016 68.812 33.6016 70.5254C33.6018 72.2385 35.0037 73.627 36.7324 73.627H63.8623C65.5908 73.6267 66.992 72.2384 66.9922 70.5254C66.9922 68.8122 65.5909 67.4231 63.8623 67.4229H36.7324ZM26.2979 53.7725C24.569 53.7725 23.167 55.1617 23.167 56.875C23.167 58.5883 24.569 59.9775 26.2979 59.9775H74.0879C75.8166 59.9774 77.2178 58.5883 77.2178 56.875C77.2178 55.1617 75.8166 53.7726 74.0879 53.7725H26.2979ZM45.9746 16.624C45.4213 16.2419 44.6624 16.6345 44.6621 17.3027V43.2549C44.6621 43.931 45.4365 44.3215 45.9883 43.9238L64.374 30.6719C64.8381 30.3374 64.8311 29.6494 64.3604 29.3242L45.9746 16.624Z"
                fill="#FFE500"
            />
        </svg>
    );
};

export default GretaLogo;
